export const POSITION_SEPARATOR = '.'
